/**
 * Error-message patterns dropped client-side via Sentry's `ignoreErrors`
 * (substring / regex match on the event message) — issue #583.
 *
 * All of these are thrown by scripts INJECTED into our pages by in-app
 * browsers (Meta apps: Instagram/Facebook on iOS), not by our code. The
 * user is unaffected; the events only burn Sentry quota and pollute the
 * issue stream (e.g. Sentry 135333228: `sendDataToNative` →
 * `window.webkit.messageHandlers` undefined, 24 events in 2 days).
 *
 * Filtering client-side (vs Sentry UI inbound filters) means the SDK never
 * sends the event at all — the free-plan error quota is preserved.
 */
export const INAPP_BROWSER_IGNORE_ERRORS: (string | RegExp)[] = [
  // Meta (Instagram/Facebook) iOS WebView bridge — sendDataToNative /
  // sendPageHideMessage blow up when the native handler is absent.
  "window.webkit.messageHandlers",
  // Facebook iOS autofill bridge, injected as _AutofillCallbackHandler.
  "_AutofillCallbackHandler",
  // Facebook pixel/creative bridge occasionally missing on iOS.
  "_pcmBridgeCallbackHandler",
];
